module.exports = __webpack_public_path__ + "static/media/doggie.22701891.jpg";